import { BaseBritishColumbiaObstetricalFileSubSection, BaseBritishColumbiaObstetricalFileSubSectionProps } from "@/Patient/Components/MedicalNote/Obstetric/Form/BritishColumbia/Subcomponent/BaseBritishColumbiaObstetricalFileSubSection";
import { BritishColumbiaObstetricalFileAlcoholSubSection } from "./Section9/BritishColumbiaObstetricalFileAlcoholSubSection";
import { BritishColumbiaObstetricalFileCannabisSubSection } from "./Section9/BritishColumbiaObstetricalFileCannabisSubSection";
import { BritishColumbiaObstetricalFileOtherDuringPregnancySubSection } from "./Section9/BritishColumbiaObstetricalFileOtherDuringPregnancySubSection";
import { BritishColumbiaObstetricalFileTobaccoSubSection } from "./Section9/BritishColumbiaObstetricalFileTobaccoSubSection";

class BritishColumbiaObstetricalFileSection9 extends BaseBritishColumbiaObstetricalFileSubSection<BaseBritishColumbiaObstetricalFileSubSectionProps, never> {
    public render(): JSX.Element {
        return (
            <div className="section border border-top">
                {this.renderTitle(9, "SubstanceUseLabel")}
                <table className="no-border-section-table">
                    <tbody>
                        <tr>
                            <td />
                            <td className="bold">{this.getString("ObstetricalFile_3MosBeforePregLabel")}</td>
                            <td className="bold">{this.getString("ObstetricalFile_DuringPregLabel")}</td>
                        </tr>
                    </tbody>
                    <BritishColumbiaObstetricalFileAlcoholSubSection {...this.props} />
                    <BritishColumbiaObstetricalFileTobaccoSubSection {...this.props} />
                    <BritishColumbiaObstetricalFileCannabisSubSection {...this.props} />
                </table>
                <BritishColumbiaObstetricalFileOtherDuringPregnancySubSection {...this.props} />
            </div>
        );
    }
}

export { BritishColumbiaObstetricalFileSection9 };
